<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M503.467,290.133H8.533c-4.719,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.814,8.533,8.533,8.533h494.933
			c4.719,0,8.533-3.814,8.533-8.533v-102.4C512,293.948,508.186,290.133,503.467,290.133z M494.933,392.533H17.067V307.2h25.6
			l-0.009,17.067c0,4.71,3.814,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533l0.009-17.067h34.133v34.133
			c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533V307.2h34.133v17.067c0,4.719,3.814,8.533,8.533,8.533
			c4.719,0,8.533-3.814,8.533-8.533V307.2h34.133v34.133c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533V307.2h34.133
			v17.067c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533V307.2h34.133v34.133c0,4.719,3.814,8.533,8.533,8.533
			s8.533-3.814,8.533-8.533V307.2h34.133v17.067c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533V307.2h34.133v34.133
			c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533V307.2h34.15l-0.009,17.067c0,4.71,3.814,8.533,8.533,8.533
			c4.71,0,8.533-3.814,8.533-8.533l0.009-17.067h25.583V392.533z"/>
	</g>
</g>
<g>
	<g>
		<path d="M8.533,102.4C3.814,102.4,0,106.214,0,110.933V256c0,4.719,3.814,8.533,8.533,8.533s8.533-3.814,8.533-8.533v-68.267
			v-76.8C17.067,106.214,13.252,102.4,8.533,102.4z"/>
	</g>
</g>
<g>
	<g>
		<path d="M503.467,102.4c-4.719,0-8.533,3.814-8.533,8.533v76.8V256c0,4.719,3.814,8.533,8.533,8.533
			c4.719,0,8.533-3.814,8.533-8.533V110.933C512,106.214,508.186,102.4,503.467,102.4z"/>
	</g>
</g>
<g>
	<g>
		<path d="M476.032,182.263l-39.62-51.2c-2.142-2.765-5.658-3.763-8.789-2.56c-3.132,1.229-5.222,4.437-5.222,8.03V179.2H89.6
			v-42.675c0-3.593-2.091-6.801-5.222-8.021c-3.132-1.22-6.639-0.213-8.789,2.56l-39.62,51.208c-1.22,1.579-1.835,3.524-1.835,5.461
			s0.614,3.883,1.835,5.47l39.62,51.2c1.536,1.98,3.78,3.063,6.084,3.063c0.905,0,1.818-0.171,2.697-0.512
			c3.132-1.229,5.222-4.437,5.222-8.021v-42.667h332.8v42.667c0,3.593,2.091,6.801,5.222,8.021c0.879,0.341,1.792,0.512,2.697,0.512
			c2.304,0,4.548-1.084,6.093-3.063l39.62-51.2c1.229-1.587,1.843-3.524,1.843-5.47S477.252,183.851,476.032,182.263z
			 M73.754,215.364l-21.385-27.631l21.385-27.631V215.364z M438.246,215.364v-55.262l21.385,27.631L438.246,215.364z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
